import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import http from "../../services/http/http";
import toast from "react-hot-toast";

// const apiUrl2 = `https://phpstack-737101-2469488.cloudwaysapps.com/mu-online`;
const apiUrl2 = "https://phpstack-737101-2642882.cloudwaysapps.com/user";
const apiUrl44 = `http://localhost:3001/user`;
const apiUrl444 = `http://51.195.253.88:3009/user`;
//const apiUrl = `http://5.180.181.26:3009/user`;
const apiUrl = `https://mu-beginning.co.il/user`;

export const login = createAsyncThunk(
  "login",
  async ({ username, password }, { rejectWithValue }) => {
    try {
      const response = await http.post(`${apiUrl}/login`, {
        username,
        password,
      });

      if (response.status == 200) {
        toast.success("You login the System Successfully");
      }
      return response.data;
    } catch (error) {
      const data = error.response?.data;
      return rejectWithValue(
        typeof data === "string" ? data : "Username or password is incorrect",
      );
    }
  },
);

export const reset = createAsyncThunk("reset", async ({ username, name }) => {
  const response = await http.post(`${apiUrl}/reset`, {
    username,
    name,
  });

  if (response.data == "You dont have enough Zen") {
    toast.error(response.data);
    return response.data;
  }

  if (response.data == "you need logout from the game to make reset") {
    toast.error(response.data);
    return response.data;
  }

  if (response.data == "you need level 400 to make reset") {
    toast.error(response.data);
    return response.data;
  }

  toast.success("you make reset successfully");

  return response.data;
});

export const pkClear = createAsyncThunk(
  "pkclear",
  async ({ username, name }) => {
    const response = await http.post(`${apiUrl}/pkclear`, {
      username,
      name,
    });

    if (response.data == "You dont have enough Zen") {
      toast.error(response.data);
      return response.data;
    }

    if (response.data == "you need logout from the game to make Pk Clear") {
      toast.error(response.data);
      return response.data;
    }

    if (response.data == "You ar not pk") {
      toast.error(response.data);
      return response.data;
    }

    toast.success("you make Pk Clear successfully");

    return response.data;
  },
);

export const getPlayer = createAsyncThunk("getPlayer", async (player) => {
  const response = await http.get(`${apiUrl}/player/${player}`);

  return response.data;
});

export const register = createAsyncThunk(
  "register",
  async ({ username, password, email, selectImg }) => {
    const response = await http.post(`${apiUrl}/register`, {
      username,
      password,
      email,
      selectImg,
    });

    return response.data;
  },
);

export const addStats = createAsyncThunk(
  "addStats",
  async ({
    username,
    name,
    StrengthFront,
    DexterityFront,
    VitalityFront,
    EnergyFront,
    CommandFront,
  }) => {
    const response = await http.post(`${apiUrl}/addStats`, {
      username,
      name,
      StrengthFront,
      DexterityFront,
      VitalityFront,
      EnergyFront,
      CommandFront,
    });

    return response.data;
  },
);

export const logout = createAsyncThunk("logout", async () => {
  const response = await http.get(`${apiUrl}/logout`);
  return response.data;
});

export const user = createAsyncThunk("user", async () => {
  const response = await http.get(`${apiUrl}/user`);
  return response.data;
});

export const sendCredits = createAsyncThunk(
  "sendCredits",
  async ({ creditsSend, usernameSend, receiverUsername }) => {
    const response = await http.post(`${apiUrl}/sendCredits`, {
      creditsSend,
      usernameSend,
      receiverUsername,
    });

    return response.data;
  },
);

export const buyCredits = createAsyncThunk(
  "buyCredits",
  async ({ credits, username }) => {
    const response = await http.post(`${apiUrl}/buyCredits`, {
      credits,
      username,
    });

    return response.data;
  },
);

export const changePassword = createAsyncThunk(
  "changePassword",
  async ({ email, newPassword }, { rejectWithValue }) => {
    try {
      const response = await http.post(`${apiUrl}/changePassword`, {
        email,
        newPassword,
      });

      if (response.data.success) {
        toast.success("Password changed successfully");
      } else {
        toast.error(response.data.error || "Failed to change password");
      }

      return response.data;
    } catch (error) {
      toast.error("Server error while changing password");
      return rejectWithValue(error.response?.data || "Error");
    }
  },
);

export const changeEmail = createAsyncThunk(
  "changeEmail",
  async ({ currentEmail, newEmail, password }, { rejectWithValue }) => {
    try {
      const response = await http.post(`${apiUrl}/changeEmail`, {
        currentEmail,
        newEmail,
        password,
      });

      if (response.data.success) {
        toast.success("Email changed successfully");
      } else {
        toast.error(response.data.error || "Failed to change email");
      }

      return response.data;
    } catch (error) {
      toast.error("Server error while changing email");
      return rejectWithValue(error.response?.data || "Error");
    }
  },
);

const initialState = {
  userLogin: {
    data: null,
    status: "",
  },

  userRegister: {
    data: null,
    status: "",
  },

  sendCredits: {
    data: [],
    status: "",
  },

  buyCredits: {
    data: [],
    status: "",
  },

  addStats: {
    data: [],
    status: "",
  },
  getPlayer: {
    data: [],
    status: "",
  },

  changePassword: {
    data: null,
    status: "",
  },

  changeEmail: {
    data: null,
    status: "",
  },
};

const userApi = createSlice({
  name: "MuOnlineUser",
  initialState,

  reducers: {
    updateUserData: (state, action) => {
      state.userLogin.data = {
        username: action.payload.username,
        data: action.payload.user,
      };
    },
  },

  extraReducers: {
    [user.pending]: (state, { payload, meta }) => {
      state.userLogin.data = payload;
      state.userLogin.status = meta.requestStatus;
    },

    [user.fulfilled]: (state, { payload, meta }) => {
      state.userLogin.data = payload;
      state.userLogin.status = "fulfilled";
    },

    [user.rejected]: (state, { meta }) => {
      state.userLogin.data = null;
      state.userLogin.status = meta.requestStatus;
    },

    [register.pending]: (state, { payload, meta }) => {
      state.userRegister.data = payload;
      state.userRegister.status = meta.requestStatus;
    },

    [register.fulfilled]: (state, { payload, meta }) => {
      state.userRegister.data = payload;
      state.userRegister.status = "fulfilled";
    },

    [register.rejected]: (state, { meta }) => {
      state.userRegister.data = null;
      state.userRegister.status = meta.requestStatus;
    },

    // [addStats.pending]: (state, { payload, meta }) => {
    //   state.addStats.data = payload;
    //   state.addStats.status = meta.requestStatus;
    // },

    [addStats.fulfilled]: (state, { payload, meta }) => {
      state.addStats.data = payload;
      state.addStats.status = "fulfilled";
      if (
        payload.result === "to add points you must logout from the game" ||
        payload.result == "you cant add points over 32767" ||
        payload.result == "You do not have enough points to up"
      ) {
        return;
      }

      state.userLogin.data = {
        username: payload.username,
        data: payload.user,
      };
    },

    // [addStats.rejected]: (state, { meta }) => {
    //   state.addStats.data = null;
    //   state.addStats.status = meta.requestStatus;
    // },

    [sendCredits.fulfilled]: (state, { payload, meta }) => {
      state.sendCredits.data = payload;
      state.sendCredits.status = "fulfilled";

      if (payload == "user not exists" || payload == "you dont have credits") {
        return;
      }

      state.userLogin.data = {
        username: payload.username,
        data: payload.user,
      };
    },
    [sendCredits.rejected]: (state, { payload, meta }) => {
      state.sendCredits.data = payload;
      state.sendCredits.status = meta.requestStatus;
    },

    [buyCredits.fulfilled]: (state, { payload, meta }) => {
      state.sendCredits.data = payload;
      state.sendCredits.status = meta.requestStatus;

      state.userLogin.data = {
        username: payload.username,
        data: payload.user,
      };
    },

    [buyCredits.rejected]: (state, { payload, meta }) => {
      state.sendCredits.data = payload;
      state.sendCredits.status = meta.requestStatus;
    },

    [login.fulfilled]: (state, { payload, meta }) => {
      state.userLogin.data = {
        username: payload.username,
        data: payload.user,
      };
      state.userLogin.status = meta.requestStatus;
    },

    [logout.fulfilled]: (state) => {
      state.userLogin.data = null;
      state.userLogin.status = "rejected";
    },

    [getPlayer.fulfilled]: (state, { payload, meta }) => {
      state.getPlayer.data = payload;
      state.userLogin.status = meta.requestStatus;
    },

    [reset.fulfilled]: (state, { payload, meta }) => {
      // state.addStats.data = payload;
      // state.addStats.status = "fulfilled";

      if (
        payload == "You dont have enough Zen" ||
        payload == "you need logout from the game to make reset" ||
        payload == "you need level 400 to make reset"
      ) {
        return;
      }

      state.userLogin.data = {
        username: payload.username,
        data: payload.user,
      };
    },

    [pkClear.fulfilled]: (state, { payload, meta }) => {
      if (
        payload == "You dont have enough Zen" ||
        payload == "you need logout from the game to make Pk Clear" ||
        payload == "You ar not pk"
      ) {
        return;
      }

      state.userLogin.data = {
        username: payload.username,
        data: payload.user,
      };
    },

    // [reset.rejected]: (state, { meta }) => {
    //   state.addStats.data = null;
    //   state.addStats.status = meta.requestStatus;
    // },

    [changePassword.pending]: (state) => {
      state.changePassword.status = "loading";
    },

    [changePassword.fulfilled]: (state, { payload }) => {
      state.changePassword.status = "fulfilled";
      state.changePassword.data = payload;
    },

    [changePassword.rejected]: (state) => {
      state.changePassword.status = "rejected";
      state.changePassword.data = null;
    },

    [changeEmail.pending]: (state) => {
      state.changePassword.status = "loading";
    },

    [changeEmail.fulfilled]: (state, { payload }) => {
      state.changePassword.status = "fulfilled";
      state.changePassword.data = payload;
    },

    [changeEmail.rejected]: (state) => {
      state.changePassword.status = "rejected";
      state.changePassword.data = null;
    },
  },
});

export const { updateUserData } = userApi.actions;
export default userApi.reducer;
